import { h } from 'preact'
import ChatChannelAvatar from 'components/ChatChannelAvatar'
import { ChatListMember } from './ChatListMember'
import './index.sass'
import { useMyOrganizations, useMyPublicProfile, usePublicProfile,
  usePublicProfiles } from 'lib/membershipAppStateHooks'
import { hubChatDisplayName } from './hubChatDisplayName'
import { renderChatChannelAvatarValue } from './renderChatChannelAvatarValue'


export function GeneralChatListMember({ senderUserDid, memberUserDids, ...props }) {

  const { myOrganizations } = useMyOrganizations('OrganizationChatPage')
  const orgName = myOrganizations.find(org => org.apikey === props.organizationApikey)?.name || props.organizationApikey
  const organization = myOrganizations.find(org => org.apikey === props.organizationApikey)

  const myPublicProfile = useMyPublicProfile('GeneralChatListMember')
  const { publicProfile: senderProfile } = usePublicProfile(senderUserDid, 'OrganizationChatPage')

  const { publicProfiles } = usePublicProfiles(memberUserDids || [], 'OrganizationChatPage')

  const senderIsNotMe = senderProfile?.did !== myPublicProfile.did
  const senderName = senderIsNotMe ? (senderProfile?.displayName || senderProfile?.username) : 'You'

  return <ChatListMember {...{
    ...props,
    organization,
    myPublicProfile,
    publicProfiles,
    name: hubChatDisplayName({ name: props.name, type: props.type, orgName }),
    orgName,
    senderName,
    avatar: <ChatChannelAvatar size="sm" value={renderChatChannelAvatarValue(props.imageUrl)} />
  }} />
}
